import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row crossword-header" }
const _hoisted_3 = { class: "col-md-12 mt-3" }
const _hoisted_4 = {
  class: "mb-0 col-12 mt-1",
  style: {"list-style-type":"none"}
}
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = {
  key: 0,
  class: "crossword-header-subtitle mb-0"
}
const _hoisted_7 = { class: "me-2" }
const _hoisted_8 = { class: "mx-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 1,
  class: "crossword-header-subtitle mb-0"
}
const _hoisted_12 = { class: "col-md-12 mt-3" }
const _hoisted_13 = { class: "header-row top-search-parent" }
const _hoisted_14 = {
  style: {"margin-right":"auto"},
  class: "d-flex"
}
const _hoisted_15 = { class: "header-misc ms-0" }
const _hoisted_16 = { class: "header-misc-icon" }
const _hoisted_17 = { class: "crossword-header-subtitle mb-0" }
const _hoisted_18 = { class: "forum-home-toolbar" }
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "header-misc-icon" }
const _hoisted_22 = {
  class: "dropdown-menu dropdown-menu-links rounded shadow-sm dropdown-menu-end py-0 m-0",
  "aria-labelledby": "menuLink",
  style: {}
}
const _hoisted_23 = { class: "header-misc-icon" }
const _hoisted_24 = {
  class: "dropdown-menu dropdown-menu-links rounded shadow-sm dropdown-menu-end py-0 m-0",
  "aria-labelledby": "menuLink",
  style: {}
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-8" }
const _hoisted_27 = {
  key: 0,
  class: "puzzle-overlay"
}
const _hoisted_28 = {
  class: "sale-flash",
  style: {"left":"0 !important","width":"100% !important"}
}
const _hoisted_29 = {
  class: "badge bg-color rounded-0 fw-normal p-2",
  style: {"width":"100% !important"}
}
const _hoisted_30 = {
  key: 0,
  class: "fs-2 my-3 fw-medium px-lg-5 text-pop-image-text"
}
const _hoisted_31 = {
  key: 1,
  class: "fs-2 my-3 fw-medium px-lg-5 text-pop-image-text mb-2"
}
const _hoisted_32 = {
  key: 2,
  class: "fs-2 my-3 fw-medium px-lg-5 text-pop-image-text"
}
const _hoisted_33 = {
  key: 3,
  class: "fs-2 my-3 fw-medium px-lg-5 text-pop-image-text"
}
const _hoisted_34 = {
  key: 4,
  class: "fs-2 my-3 fw-medium px-lg-5 text-pop-image-text"
}
const _hoisted_35 = {
  key: 5,
  class: "lh-sm small my-3 op-06 px-lg-5",
  style: {"white-space":"normal"}
}
const _hoisted_36 = {
  key: 6,
  class: "lh-sm small my-3 op-06 px-lg-5",
  style: {"white-space":"normal"}
}
const _hoisted_37 = {
  key: 7,
  class: "lh-sm small my-3 op-06 px-lg-5",
  style: {"white-space":"normal"}
}
const _hoisted_38 = { style: {"white-space":"normal"} }
const _hoisted_39 = {
  key: 8,
  class: "my-3 px-lg-5"
}
const _hoisted_40 = {
  key: 0,
  class: "race-result-container mt-3"
}
const _hoisted_41 = {
  key: 1,
  class: "race-result-container mt-3"
}
const _hoisted_42 = {
  key: 1,
  class: "puzzle-overlay"
}
const _hoisted_43 = {
  class: "col-lg-4",
  id: "crossword-race-box"
}
const _hoisted_44 = { class: "row" }
const _hoisted_45 = {
  key: 0,
  class: "col-12 col-lg-4 ms-auto"
}
const _hoisted_46 = { class: "container mt-5" }
const _hoisted_47 = { class: "row gx-5 col-mb-50" }
const _hoisted_48 = { class: "col-lg-8 col-xl-8 portfolio-single-content px-5 ps-xl-5 pt-xl-4" }
const _hoisted_49 = { class: "row g-4 mt-4" }
const _hoisted_50 = { class: "col-6" }
const _hoisted_51 = ["href"]
const _hoisted_52 = ["href"]
const _hoisted_53 = {
  class: "modal fade",
  id: "crosswordSettingsModal",
  tabindex: "-1",
  "aria-labelledby": "crosswordSettingsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_54 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_55 = { class: "modal-content" }
const _hoisted_56 = { class: "modal-body" }
const _hoisted_57 = { class: "row p-4 bg-white d-flex align-items-center justify-content-center rounded" }
const _hoisted_58 = { class: "col-12 p-4" }
const _hoisted_59 = { class: "row mb-3 align-items-center" }
const _hoisted_60 = { class: "col-2 col-sm-2 d-flex justify-content-end" }
const _hoisted_61 = { class: "form-check form-switch" }
const _hoisted_62 = { class: "row mb-3 align-items-center" }
const _hoisted_63 = { class: "col-2 col-sm-2 d-flex justify-content-end" }
const _hoisted_64 = { class: "form-check form-switch" }
const _hoisted_65 = { class: "row mb-5 align-items-center" }
const _hoisted_66 = { class: "col-2 col-sm-2 d-flex justify-content-end" }
const _hoisted_67 = { class: "form-check form-switch" }
const _hoisted_68 = {
  class: "modal fade",
  id: "createLobbyModalId",
  tabindex: "-1",
  "aria-labelledby": "createLobbyModalLabel",
  "aria-hidden": "true"
}
const _hoisted_69 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_70 = { class: "modal-content" }
const _hoisted_71 = { class: "modal-body" }
const _hoisted_72 = { class: "row p-4 bg-white d-flex align-items-center justify-content-center rounded" }
const _hoisted_73 = { class: "col-md-12 p-4" }
const _hoisted_74 = { class: "row mb-3 align-items-center" }
const _hoisted_75 = { class: "col-2 col-sm-2 d-flex justify-content-end" }
const _hoisted_76 = { class: "form-check form-switch" }
const _hoisted_77 = { class: "row mb-3 align-items-center" }
const _hoisted_78 = { class: "col-2 col-sm-2 d-flex justify-content-end" }
const _hoisted_79 = { class: "form-check form-switch" }
const _hoisted_80 = {
  class: "modal fade",
  id: "changeRoomPuzzlePreferencesModalId",
  tabindex: "-1",
  "aria-labelledby": "changeRoomPuzzlePreferencesModalLabel",
  "aria-hidden": "true"
}
const _hoisted_81 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_82 = { class: "modal-content" }
const _hoisted_83 = { class: "modal-body" }
const _hoisted_84 = { class: "row p-4 bg-white d-flex align-items-center justify-content-center rounded" }
const _hoisted_85 = { class: "col-md-12 p-4" }
const _hoisted_86 = {
  class: "modal fade",
  id: "revealPuzzleModalId",
  tabindex: "-1",
  "aria-labelledby": "revealPuzzleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_87 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_88 = { class: "modal-content" }
const _hoisted_89 = { class: "modal-body" }
const _hoisted_90 = { class: "row p-4 bg-white d-flex align-items-center justify-content-center rounded" }
const _hoisted_91 = { class: "col-md-12 p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RaceTimer = _resolveComponent("RaceTimer")!
  const _component_RevealedPuzzle = _resolveComponent("RevealedPuzzle")!
  const _component_RaceResult = _resolveComponent("RaceResult")!
  const _component_FinalRaceResult = _resolveComponent("FinalRaceResult")!
  const _component_Puzzle = _resolveComponent("Puzzle")!
  const _component_PuzzleGhost = _resolveComponent("PuzzleGhost")!
  const _component_Chat = _resolveComponent("Chat")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[28] || (_cache[28] = _createStaticVNode("<div class=\"d-flex align-items-center justify-content-between mt-1\" data-v-7d3ba0ec><p class=\"color text-uppercase mb-0\" data-v-7d3ba0ec><span data-v-7d3ba0ec><a href=\"/\" data-v-7d3ba0ec>Crossword Race</a></span><span class=\"mx-2\" data-v-7d3ba0ec>/</span><span data-v-7d3ba0ec><a href=\"/crossword/live\" data-v-7d3ba0ec>Live Arena</a></span></p></div>", 1)),
          _createElementVNode("li", _hoisted_4, [
            _cache[27] || (_cache[27] = _createElementVNode("h1", { class: "mb-0" }, "Live Crossword Arena", -1)),
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.isWaitForJoin)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    _createElementVNode("li", _hoisted_7, [
                      _createTextVNode("Lobby " + _toDisplayString(_ctx.roomId), 1),
                      _createElementVNode("i", {
                        class: "bi bi-arrow-clockwise ms-2",
                        style: {"cursor":"pointer","font-size":"small"},
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.joinNewLobby && _ctx.joinNewLobby(...args)))
                      })
                    ]),
                    _cache[25] || (_cache[25] = _createTextVNode(" ○ ")),
                    _createElementVNode("li", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.playerCount) + " ", 1),
                      (_ctx.playerCount === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "player"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_10, "players"))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_11, _cache[26] || (_cache[26] = [
                    _createElementVNode("li", { class: "me-2" }, "Searching for lobby...", -1)
                  ])))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, [
                _createVNode(_component_RaceTimer, { ref: "puzzleTimer" }, null, 512)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("ul", _hoisted_17, [
                  _createElementVNode("li", _hoisted_18, [
                    _cache[29] || (_cache[29] = _createElementVNode("label", {
                      for: "roomIdSelect",
                      class: "visually-hidden"
                    }, "Select Room Mode", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select custom-select-dropdown",
                      id: "roomIdSelect",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.roomPuzzlePreferences) = $event)),
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeRoomPuzzlePreferences && _ctx.changeRoomPuzzlePreferences(...args)))
                    }, [
                      _createElementVNode("option", {
                        value: _ctx.roomPuzzlePreferencesEnum.AI_PUZZLES
                      }, "A.I. Puzzles", 8, _hoisted_19),
                      _createElementVNode("option", {
                        value: _ctx.roomPuzzlePreferencesEnum.COMMUNITY_PUZZLES
                      }, "Community Puzzles", 8, _hoisted_20)
                    ], 544), [
                      [_vModelSelect, _ctx.roomPuzzlePreferences]
                    ])
                  ])
                ])
              ]),
              _cache[42] || (_cache[42] = _createElementVNode("div", { class: "header-misc-icon" }, [
                _createElementVNode("a", {
                  href: "#",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#crosswordSettingsModal"
                }, [
                  _createElementVNode("i", { class: "bi bi-gear" })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_21, [
                _cache[34] || (_cache[34] = _createElementVNode("a", {
                  href: "#",
                  id: "menuLink",
                  "data-bs-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  class: ""
                }, [
                  _createElementVNode("i", { class: "bi bi-pencil-square" })
                ], -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["dropdown-item", { 'disabled': !_ctx.crossword || _ctx.isPuzzleLocked }]),
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showRevealModal && _ctx.showRevealModal(...args)))
                  }, _cache[30] || (_cache[30] = [
                    _createElementVNode("i", { class: "bi bi-pencil me-2" }, null, -1),
                    _createTextVNode("Reveal Puzzle ")
                  ]), 2),
                  _createElementVNode("a", {
                    class: _normalizeClass(["dropdown-item", { 'disabled': !_ctx.crossword || _ctx.isPuzzleLocked }]),
                    href: "#",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.revealSquare && _ctx.revealSquare(...args)))
                  }, _cache[31] || (_cache[31] = [
                    _createElementVNode("i", { class: "bi bi-pencil-fill me-2" }, null, -1),
                    _createTextVNode("Reveal Square ")
                  ]), 2),
                  _createElementVNode("a", {
                    class: _normalizeClass(["dropdown-item", { 'disabled': !_ctx.crossword || _ctx.isPuzzleLocked }]),
                    href: "#",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkPuzzle && _ctx.checkPuzzle(...args)))
                  }, _cache[32] || (_cache[32] = [
                    _createElementVNode("i", { class: "bi bi-check-circle me-2" }, null, -1),
                    _createTextVNode("Check Puzzle ")
                  ]), 2),
                  _createElementVNode("a", {
                    class: _normalizeClass(["dropdown-item", { 'disabled': !_ctx.crossword || _ctx.isPuzzleLocked }]),
                    href: "#",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.checkSquare && _ctx.checkSquare(...args)))
                  }, _cache[33] || (_cache[33] = [
                    _createElementVNode("i", { class: "bi bi-check-circle-fill me-2" }, null, -1),
                    _createTextVNode("Check Square ")
                  ]), 2)
                ])
              ]),
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "header-misc-icon" }, [
                _createElementVNode("a", {
                  href: "/post/How%20to%20Play",
                  target: "_blank"
                }, [
                  _createElementVNode("i", { class: "bi-question-circle" })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_23, [
                _cache[41] || (_cache[41] = _createElementVNode("a", {
                  href: "#",
                  id: "menuLink",
                  "data-bs-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  class: ""
                }, [
                  _createElementVNode("i", { class: "bi bi-three-dots" })
                ], -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetPuzzle && _ctx.resetPuzzle(...args)))
                  }, _cache[35] || (_cache[35] = [
                    _createElementVNode("i", { class: "bi-x-circle me-2" }, null, -1),
                    _createTextVNode("Reset Grid ")
                  ])),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.createNewLobby && _ctx.createNewLobby(...args)))
                  }, _cache[36] || (_cache[36] = [
                    _createElementVNode("i", { class: "bi bi-plus-square me-2" }, null, -1),
                    _createTextVNode("Create Lobby ")
                  ])),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.copyLobbyLink && _ctx.copyLobbyLink(...args)))
                  }, _cache[37] || (_cache[37] = [
                    _createElementVNode("i", { class: "bi bi-copy me-2" }, null, -1),
                    _createTextVNode("Copy Lobby Link ")
                  ])),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    href: "#",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.flagContent('CrosswordRace')))
                  }, _cache[38] || (_cache[38] = [
                    _createElementVNode("i", { class: "bi-flag me-2" }, null, -1),
                    _createTextVNode("Flag Content ")
                  ])),
                  (!_ctx.isShowVirtualKeyboard())
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "dropdown-item",
                        href: "#",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleShowVirtualKeyboard(true)))
                      }, _cache[39] || (_cache[39] = [
                        _createElementVNode("i", { class: "bi bi-keyboard me-2" }, null, -1),
                        _createTextVNode("Enable Virtual Keyboard ")
                      ])))
                    : _createCommentVNode("", true),
                  (_ctx.isShowVirtualKeyboard())
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "dropdown-item",
                        href: "#",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toggleShowVirtualKeyboard(false)))
                      }, _cache[40] || (_cache[40] = [
                        _createElementVNode("i", { class: "bi bi-keyboard me-2" }, null, -1),
                        _createTextVNode("Disable Virtual Keyboard ")
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          (_ctx.showPuzzleOverlay && !_ctx.showActivityWarning)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.gameStatus === _ctx.raceStatusEnum.JOINING)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_30, _cache[44] || (_cache[44] = [
                          _createElementVNode("div", { class: "loading-text" }, [
                            _createTextVNode(" Joining a lobby"),
                            _createElementVNode("span", { class: "dots" }, [
                              _createElementVNode("span", null, "."),
                              _createElementVNode("span", null, "."),
                              _createElementVNode("span", null, ".")
                            ])
                          ], -1)
                        ])))
                      : _createCommentVNode("", true),
                    (_ctx.gameStatus === _ctx.raceStatusEnum.COUNTDOWN)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_31, " Next game starting in " + _toDisplayString(_ctx.countdown), 1))
                      : _createCommentVNode("", true),
                    (_ctx.gameStatus === _ctx.raceStatusEnum.WAITING)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_32, _cache[45] || (_cache[45] = [
                          _createElementVNode("div", { class: "loading-text" }, [
                            _createTextVNode(" Waiting for round to end"),
                            _createElementVNode("span", { class: "dots" }, [
                              _createElementVNode("span", null, "."),
                              _createElementVNode("span", null, "."),
                              _createElementVNode("span", null, ".")
                            ])
                          ], -1)
                        ])))
                      : _createCommentVNode("", true),
                    (_ctx.gameStatus === _ctx.raceStatusEnum.SOLVED)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_33, " Completed in " + _toDisplayString(this.getTime()), 1))
                      : _createCommentVNode("", true),
                    (_ctx.gameStatus === _ctx.raceStatusEnum.REVEALED)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_34, " Puzzle Revealed "))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoggedIn)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createTextVNode(" You’re playing as " + _toDisplayString(_ctx.username) + ". ", 1),
                          _cache[46] || (_cache[46] = _createElementVNode("a", {
                            style: {"text-decoration":"underline !important","color":"white","text-underline-offset":"2.5px !important","cursor":"pointer"},
                            href: "/signIn"
                          }, "Create an account", -1)),
                          _cache[47] || (_cache[47] = _createTextVNode(" to save your progress and join the leaderboard! "))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createTextVNode(" You’re playing as " + _toDisplayString(_ctx.username) + ". Want to see how you stack up against other players? Check out the ", 1),
                          _cache[48] || (_cache[48] = _createElementVNode("a", {
                            style: {"text-decoration":"underline !important","color":"white","text-underline-offset":"2.5px !important","cursor":"pointer"},
                            href: "/crossword/leaderboard"
                          }, "leaderboard!", -1))
                        ])),
                    (_ctx.gameStatus === _ctx.raceStatusEnum.WAITING || _ctx.gameStatus === _ctx.raceStatusEnum.SOLVED || _ctx.gameStatus === _ctx.raceStatusEnum.REVEALED)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _cache[49] || (_cache[49] = _createTextVNode(" Don't want to wait? ")),
                            _createElementVNode("a", {
                              style: {"text-decoration":"underline !important","color":"white","text-underline-offset":"2.5px !important","cursor":"pointer"},
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.joinNewLobby && _ctx.joinNewLobby(...args)))
                            }, "Create a new lobby.")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.gameStatus === _ctx.raceStatusEnum.REVEALED)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createVNode(_component_RevealedPuzzle, { crossword: _ctx.crossword }, null, 8, ["crossword"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.raceResults != null && this.gameStatus === _ctx.raceStatusEnum.SOLVED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createVNode(_component_RaceResult, { raceResults: _ctx.raceResults }, null, 8, ["raceResults"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.finalRaceResults != null && this.gameStatus === _ctx.raceStatusEnum.COUNTDOWN)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createVNode(_component_FinalRaceResult, { raceResults: _ctx.finalRaceResults }, null, 8, ["raceResults"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showActivityWarning)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[50] || (_cache[50] = [
                _createElementVNode("div", {
                  class: "sale-flash",
                  style: {"left":"0 !important","width":"100% !important"}
                }, [
                  _createElementVNode("div", {
                    class: "badge bg-color rounded-0 fw-normal p-2",
                    style: {"width":"100% !important"}
                  }, [
                    _createElementVNode("h3", { class: "fs-2 my-3 fw-medium px-lg-5 text-pop-image-text mb-2" }, " Are you still there? "),
                    _createElementVNode("div", {
                      class: "lh-sm small my-3 op-06 px-lg-5",
                      style: {"white-space":"normal"}
                    }, " Move mouse or click to return to puzzle. Otherwise, you will be redirected shortly. ")
                  ])
                ], -1)
              ])))
            : _createCommentVNode("", true),
          _createVNode(_component_Puzzle, {
            crossword: _ctx.crossword,
            isPuzzleLocked: _ctx.isPuzzleLocked,
            ref: "puzzle"
          }, null, 8, ["crossword", "isPuzzleLocked"])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createVNode(_component_PuzzleGhost, {
            crossword: _ctx.crossword,
            socket: _ctx.socket,
            messages: _ctx.gameMessages
          }, null, 8, ["crossword", "socket", "messages"])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        (!_ctx.isApiCallInProgress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createVNode(_component_Chat, {
                socket: _ctx.socket,
                messages: _ctx.lobbyMessages
              }, null, 8, ["socket", "messages"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _cache[54] || (_cache[54] = _createElementVNode("h3", { class: "fs-3 fw-bold" }, "About Crossword Race", -1)),
            _cache[55] || (_cache[55] = _createElementVNode("p", null, " Welcome to the Live Crossword Arena, where players from around the world come together to solve puzzles in real time. Compete against others, sharpen your skills, and see how fast you can solve the puzzle. Whether you're a casual solver or a crossword enthusiast, there's always a game waiting for you. ", -1)),
            _cache[56] || (_cache[56] = _createElementVNode("a", {
              href: "/post/How%20to%20Play",
              target: "_blank",
              class: "button button-border button-dark rounded-pill ms-0"
            }, [
              _createTextVNode("How To Play"),
              _createElementVNode("i", { class: "bi-arrow-right ms-2" })
            ], -1)),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _cache[53] || (_cache[53] = _createElementVNode("h5", { class: "mb-2" }, "Share", -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: _ctx.facebookShareLink,
                    class: "social-icon si-small text-white border-transparent rounded-circle bg-facebook",
                    title: "Facebook"
                  }, _cache[51] || (_cache[51] = [
                    _createElementVNode("i", { class: "fa-brands fa-facebook-f" }, null, -1),
                    _createElementVNode("i", { class: "fa-brands fa-facebook-f" }, null, -1)
                  ]), 8, _hoisted_51),
                  _createElementVNode("a", {
                    href: _ctx.twitterShareLink,
                    class: "social-icon si-small text-white border-transparent rounded-circle bg-x-twitter",
                    title: "Twitter"
                  }, _cache[52] || (_cache[52] = [
                    _createElementVNode("i", { class: "fa-brands fa-x-twitter" }, null, -1),
                    _createElementVNode("i", { class: "fa-brands fa-x-twitter" }, null, -1)
                  ]), 8, _hoisted_52)
                ])
              ])
            ])
          ]),
          _cache[57] || (_cache[57] = _createElementVNode("div", { class: "col-lg-4 col-xl-4 portfolio-single-image" }, [
            _createElementVNode("img", {
              src: "/demos/mj/cc_players.png",
              style: {"max-height":"300px","object-fit":"contain"},
              loading: "lazy"
            })
          ], -1))
        ])
      ])
    ]),
    _cache[74] || (_cache[74] = _createStaticVNode("<div class=\"section bg-transparent my-0 py-0\" data-v-7d3ba0ec><div class=\"container-fluid py-6\" data-v-7d3ba0ec><div class=\"row justify-content-center mx-auto mw-md gx-5\" data-v-7d3ba0ec><div class=\"col\" data-v-7d3ba0ec><p class=\"h6 mb-0\" data-v-7d3ba0ec> We pride ourselves on maintaining a positive, friendly community atmosphere, so let&#39;s keep it fun and fair for everyone. If you encounter any bugs, or notice any players who aren&#39;t being good sports, using inappropriate language, or cheating, please let us know. We also appreciate feedback on any weird or questionable clues — your input helps us improve the experience. Need to get in touch? <a href=\"/about#contact\" data-v-7d3ba0ec>Contact Us</a></p></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _cache[63] || (_cache[63] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _cache[61] || (_cache[61] = _createElementVNode("h3", { class: "mb-2" }, "Crossword Settings", -1)),
                _createElementVNode("div", _hoisted_59, [
                  _cache[58] || (_cache[58] = _createElementVNode("label", {
                    class: "col-10 col-sm-10",
                    for: "basic-url"
                  }, [
                    _createElementVNode("h4", { class: "mb-1 d-block fw-medium fs-6" }, "Letter Input"),
                    _createElementVNode("p", { class: "text-contrast-600 mb-0" }, " When toggled, skip over filled letters while entering a clue. Otherwise, you will re-enter letters to fill out a clue. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "flexSwitchCheckDefault",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.crosswordSettings.skipFilledLetters) = $event)),
                        onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.updateSkipFilledLettersSetting && _ctx.updateSkipFilledLettersSetting(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.crosswordSettings.skipFilledLetters]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _cache[59] || (_cache[59] = _createElementVNode("label", {
                    class: "col-10 col-sm-10",
                    for: "basic-url"
                  }, [
                    _createElementVNode("h4", { class: "mb-1 d-block fw-medium fs-6" }, "Clue Completion"),
                    _createElementVNode("p", { class: "text-contrast-600 mb-0" }, " When toggled, you will automatically move to the next clue. Otherwise, you will stay on the previous clue. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "flexSwitchCheckDefault",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.crosswordSettings.moveToNextClueAtEndOfWord) = $event)),
                        onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.updateMoveToNextClueAtEndOfWordSetting && _ctx.updateMoveToNextClueAtEndOfWordSetting(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.crosswordSettings.moveToNextClueAtEndOfWord]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _cache[60] || (_cache[60] = _createElementVNode("label", {
                    class: "col-10 col-sm-10",
                    for: "basic-url"
                  }, [
                    _createElementVNode("h4", { class: "mb-1 d-block fw-medium fs-6" }, "Spacebar"),
                    _createElementVNode("p", { class: "text-contrast-600 mb-0" }, " When toggled, spacebar will toggle between across/down clues. Otherwise, spacebar will move to the next clue. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "flexSwitchCheckDefault",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.crosswordSettings.spaceToggleDirection) = $event)),
                        onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.updateSpaceToggleDirectionSetting && _ctx.updateSpaceToggleDirectionSetting(...args)))
                      }, null, 544), [
                        [_vModelCheckbox, _ctx.crosswordSettings.spaceToggleDirection]
                      ])
                    ])
                  ])
                ]),
                _cache[62] || (_cache[62] = _createElementVNode("button", {
                  type: "button",
                  class: "button button-large m-0 bg-color text-light h-op-08",
                  "data-bs-dismiss": "modal"
                }, " Close ", -1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_68, [
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _cache[67] || (_cache[67] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _cache[66] || (_cache[66] = _createElementVNode("h3", { class: "mb-2" }, " Create Lobby ", -1)),
                _createElementVNode("div", _hoisted_74, [
                  _cache[64] || (_cache[64] = _createElementVNode("label", {
                    class: "col-10 col-sm-10",
                    for: "basic-url"
                  }, [
                    _createElementVNode("h4", { class: "mb-1 d-block fw-medium fs-6" }, "Puzzle Type"),
                    _createElementVNode("p", { class: "text-contrast-600 mb-0" }, " When toggled, puzzles in the Live Arena will be sourced from Community Puzzles created by site members. Otherwise, automatically generated puzzles will be used. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.createRoomCommunityMode) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.createRoomCommunityMode]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _cache[65] || (_cache[65] = _createElementVNode("label", {
                    class: "col-10 col-sm-10",
                    for: "basic-url"
                  }, [
                    _createElementVNode("h4", { class: "mb-1 d-block fw-medium fs-6" }, "Privacy"),
                    _createElementVNode("p", { class: "text-contrast-600 mb-0" }, " When enabled, only players with the share link can join. Otherwise, any player can join. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.createRoomPrivacyMode) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.createRoomPrivacyMode]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "button button-large m-0 bg-color text-light h-op-08",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.launchNewLobby && _ctx.launchNewLobby(...args))),
                  "data-bs-dismiss": "modal"
                }, "Create")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_80, [
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _cache[70] || (_cache[70] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _cache[68] || (_cache[68] = _createElementVNode("h3", { class: "mb-2" }, " Change Room Preferences ", -1)),
                _cache[69] || (_cache[69] = _createElementVNode("p", { class: "mb-4 fw-normal text-smaller text-black-50" }, " Updating your room preferences will require you to join a new lobby. Are you sure you want to continue? ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "button button-large m-0 bg-color text-light h-op-08",
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.confirmRoomPuzzlePreferences && _ctx.confirmRoomPuzzlePreferences(...args))),
                  "data-bs-dismiss": "modal"
                }, "Confirm")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _cache[73] || (_cache[73] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _cache[71] || (_cache[71] = _createElementVNode("h3", { class: "mb-2" }, " Confirm Reveal Puzzle ", -1)),
                _cache[72] || (_cache[72] = _createElementVNode("p", { class: "mb-4 fw-normal text-smaller text-black-50" }, " Revealing the puzzle will forfeit the round. Are you sure you want to continue? ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "button button-large m-0 bg-color text-light h-op-08",
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.confirmRevealPuzzle && _ctx.confirmRevealPuzzle(...args))),
                  "data-bs-dismiss": "modal"
                }, "Confirm")
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}